export default __webpack_public_path__ + "static/media/applications-image-27.27c8f7b4.jpg";